<div class="input-container no-border">
  <div class="row">
    <div class="column income-label">
      <span>{{ fieldsLabel | translate }}</span>
    </div>
    <div class="column">
      <div class="row">
        <div class="column">
          <app-form-input
            [errors]="amountErrors"
            [label]="amountLabel"
            [placeholder]="placeholder"
            [(model)]="amount"
            (modelChange)="onAmountChange($event)"
          ></app-form-input>
        </div>
        <div class="column">
          <app-form-select
            [errors]="percentErrors"
            [label]="percentLabel"
            [isVerification]="false"
            [employerStage]="true"
            [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REVERSE_CHARGE.PLACEHOLDER'"
            [(model)]="percent"
            (modelChange)="onPercentChange($event)"
            [choices]="vatRates"
            [valueName]="'name'"
            [optionName]="'name'"
            [isDisabled]="false"
            [currentName]="'taxClass'"
          ></app-form-select>
        </div>
        <div class="column">
          <app-form-input
            [label]="resultLabel"
            [placeholder]="''"
            [(model)]="calculated"
            [isDisabled]="isDisabled"
          ></app-form-input>
        </div>
      </div>
    </div>
  </div>
</div>
